import { Injectable} from '@angular/core';
import { ContractStepModel } from '../../../models/contract.model';
import { FileDataResponse } from '../../../services/api/documents-api.service';
import { HelpersService } from '../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { ITaskTargetResponse } from '../../../models/task.model';
import { IMultiPaymentStateCS } from '../../../models/finance.model';
import { ContractDataService } from './contract-data.service';
interface targetLoadRes {
  guid:string,
  loaded:boolean,
  error:boolean
}
@Injectable({
    providedIn: 'root'
})
export class ContractStepNameService {
  constructor (
    private contractDataService:ContractDataService,
    private helpersService:HelpersService,
    private translateService:TranslateService,
  ) { }
  shareStepNameData(step: ContractStepModel) {
    let newStepName = this.stepNameGenerator(step) 
      this.contractDataService.subStepDataChanged.next({
          stepName: newStepName?.stepName||'',
          step: step,
      });
  }
  stepNameGenerator(step:ContractStepModel): { stepName: string, isClear: boolean }|null {
    let stepName: string;
    let isClear: boolean;
    let targetData = this.contractDataService.getCachedStepTargetData(step)
    if (step.name) {
        stepName = step.name;
        isClear = false;
        return {stepName, isClear};
    } 
    if (!targetData) {
        stepName = step.target_key ? this.translateService.instant('CONTRACTS.TEXT.STEPS_NAME.GET_INFO')
            : this.helpersService.defaultContractStepName(step);
        isClear = true;
        return {stepName, isClear};
    }
    if (this.contractDataService.targetsWithErrorLoading.includes(step.target_key||'')) {
      stepName = this.translateService.instant('CONTRACTS.TEXT.STEPS_NAME.ERROR');
      isClear = true;
      return {stepName, isClear};
    }
    if (targetData) {
      switch (step.target_type) {
        case 'file':
          stepName = this.helpersService.defaultContractStepName(step, (targetData as FileDataResponse).document);
        break;
        case 'task':
          stepName = this.helpersService.defaultContractStepName(step, (targetData as ITaskTargetResponse).task);
        break;
        case 'direct_payment':
        case 'payment':
          stepName = this.helpersService.defaultContractStepName(step, step.payment_data);
        break;
        case 'multi_payment':
          stepName = this.helpersService.defaultContractStepName(step, (targetData as IMultiPaymentStateCS));
        break;
            
        default:
        stepName = this.helpersService.defaultContractStepName(step, targetData);
        break;
      }
      isClear = true;
      return {stepName, isClear};
    }
    return null
  }

  

}